import { Link } from 'react-router-dom';
import FadeInSection from '../../../components/feature/FadeInSection';

const reasons = [
  {
    id: 1,
    icon: 'ri-heart-line',
    title: '丁寧なサポート',
    description:
      '経験豊富なカウンセラーが、一人ひとりに寄り添った丁寧なサポートを提供します。焦らず、あなたのペースで進められるよう全力でお手伝いします。',
    imageUrl:
      'https://media.genaiweb.ai/8a4f04ed-3960-472b-978d-5363f01a3123/reason1.jpg',
  },
  {
    id: 2,
    icon: 'ri-user-smile-line',
    title: '選ばれるプロフィール',
    description:
      'プロフィール作成から写真撮影まで、あなたの魅力を最大限に引き出すサポートを行います。充実したプロフィールが、良いご縁へとつながります。',
    imageUrl:
      'https://media.genaiweb.ai/8a4f04ed-3960-472b-978d-5363f01a3123/reason2.jpg',
  },
  {
    id: 3,
    icon: 'ri-award-line',
    title: '大人世代に特化した実績',
    description:
      '50代・60代・70代のシニア婚活に特化した豊富な実績。シニア世代特有の悩みや希望を深く理解したカウンセラーが、確実なご縁へと導きます。',
    imageUrl:
      'https://media.genaiweb.ai/8a4f04ed-3960-472b-978d-5363f01a3123/reason3.jpg',
  },
];

export default function ReasonsSection() {
  return (
    <section className="section-padding" style={{ background: '#fff' }}>
      <div className="content-width">
        <FadeInSection className="text-center mb-8 md:mb-14">
          <p
            className="inline-block px-4 py-1 rounded-full mb-4 text-sm font-bold"
            style={{ background: '#fff8f2', color: '#8b4513', border: '1px solid #d4a574' }}
          >
            選ばれる理由
          </p>
          <h2 style={{ color: '#4a3728' }}>「和はは」が選ばれる理由</h2>
        </FadeInSection>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <FadeInSection key={reason.id} delay={index * 120} className="h-full">
              <div className="card-base h-full flex flex-col">
                <div className="w-full h-[200px] rounded-lg overflow-hidden mb-6">
                  <img
                    src={reason.imageUrl}
                    alt={`${reason.title} - 和はは`}
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                    decoding="async"
                    width={640}
                    height={200}
                  />
                </div>
                <div
                  className="flex items-center justify-center w-12 h-12 rounded-full mb-4"
                  style={{ background: '#f2f8f4' }}
                >
                  <span className="flex items-center justify-center w-7 h-7">
                    <i className={`${reason.icon} text-[#5a9e6f] text-2xl`}></i>
                  </span>
                </div>
                <h3 style={{ color: '#8b4513', marginBottom: '12px' }}>{reason.title}</h3>
                <p style={{ color: '#6b5a4e', lineHeight: '1.9', fontSize: 'clamp(13px, 1.5vw, 16px)' }} className="flex-1">
                  {reason.description}
                </p>
              </div>
            </FadeInSection>
          ))}
        </div>

        <FadeInSection className="text-center mt-10">
          <Link
            to="/reason"
            style={{
              color: '#8b4513',
              fontSize: '15px',
              fontWeight: '600',
              borderBottom: '1px solid #d4a574',
              paddingBottom: '2px',
            }}
            className="hover:opacity-70 transition-opacity whitespace-nowrap inline-flex items-center gap-1"
          >
            選ばれる理由をもっと見る
            <i className="ri-arrow-right-line"></i>
          </Link>
        </FadeInSection>
      </div>
    </section>
  );
}
